'use client';

import React, { useEffect, useState } from 'react';
import Icon from '@/components/ui/AppIcon';
import { createClient } from '@/lib/supabase/client';

interface StatItem {
  id: string;
  value: string;
  label: string;
  icon: string;
}

const defaultStats: StatItem[] = [
  { id: 'stat-youth', value: '…', label: 'Youth Empowered', icon: 'UserGroupIcon' },
  { id: 'stat-workshops', value: '…', label: 'Workshops Offered', icon: 'AcademicCapIcon' },
  { id: 'stat-registrations', value: '…', label: 'Workshop Sign-ups', icon: 'ClipboardDocumentListIcon' },
  { id: 'stat-countries', value: '8', label: 'Countries Reached', icon: 'GlobeAltIcon' },
];

export default function StatsSection() {
  const [stats, setStats] = useState<StatItem[]>(defaultStats);

  useEffect(() => {
    const fetchStats = async () => {
      const supabase = createClient();

      const [membersRes, registrationsRes] = await Promise.all([
        supabase.from('user_profiles').select('id', { count: 'exact', head: true }),
        supabase.from('workshop_registrations').select('id', { count: 'exact', head: true }),
      ]);

      const memberCount = membersRes.count ?? 0;
      const regCount = registrationsRes.count ?? 0;

      setStats([
        {
          id: 'stat-youth',
          value: memberCount > 0 ? memberCount.toString() : '0',
          label: 'Youth Empowered',
          icon: 'UserGroupIcon',
        },
        {
          id: 'stat-workshops',
          value: '12',
          label: 'Workshops Offered',
          icon: 'AcademicCapIcon',
        },
        {
          id: 'stat-registrations',
          value: regCount > 0 ? regCount.toString() : '0',
          label: 'Workshop Sign-ups',
          icon: 'ClipboardDocumentListIcon',
        },
        {
          id: 'stat-countries',
          value: '8',
          label: 'Countries Reached',
          icon: 'GlobeAltIcon',
        },
      ]);
    };

    fetchStats();
  }, []);

  return (
    <section className="bg-primary py-12">
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-8 xl:px-10 2xl:px-16">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {stats.map((stat) => (
            <div
              key={stat.id}
              className="flex flex-col items-center text-center p-6 rounded-lg bg-white/5 border border-white/10"
            >
              <div className="w-10 h-10 rounded bg-accent/20 flex items-center justify-center mb-3">
                <Icon name={stat.icon as any} size={20} variant="outline" className="text-accent" />
              </div>
              <p className="text-3xl font-bold text-white font-tabular mb-1">{stat.value}</p>
              <p className="text-xs font-semibold text-zinc-400 uppercase tracking-wider">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}